import { render, staticRenderFns } from "./Landdata.vue?vue&type=template&id=00dc90c1&scoped=true&"
import script from "./Landdata.vue?vue&type=script&lang=js&"
export * from "./Landdata.vue?vue&type=script&lang=js&"
import style0 from "./Landdata.vue?vue&type=style&index=0&id=00dc90c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00dc90c1",
  null
  
)

export default component.exports